import React from 'react';
import classNames from 'classnames';

import { Link } from '@mm/components';

import { SignUpLogo } from '../../../../../dashboard/pages/SignUp/SignUp/SignUpLogo/SignUpLogo';
import rainbowUnicorn from 'assets/rainbow-unicorn.svg';
import css from './BlueLayout.module.css';
import { Badges } from '../components/Badges/Badges';
import { useAuthBtn } from '../use-auth-btn';

type Props = {
  className?: string;
  children?: any;
  hideTrial?: boolean;
};

export const BlueLayout = ({ className, children, hideTrial }: Props) => {
  const { authBtnText, authLinkDestination, isSignUp, isResetPassword } =
    useAuthBtn();

  return (
    <div className={classNames(className, css.wrapper)}>
      <div className={css.background}>
        <div className={css.left} />
        <div
          className={classNames(css.right, {
            [css.signInRightBackground]: !isSignUp,
          })}
        />
      </div>

      <div
        className={classNames(css.container, {
          [css.signInContainer]: !isSignUp,
        })}
      >
        <div className={css.navbar}>
          <SignUpLogo className={css.logo} />
          <Link className={css.login} to={authLinkDestination}>
            {authBtnText}
          </Link>
        </div>

        <div
          className={classNames(css.content, {
            [css.contentSignIn]: !isSignUp,
          })}
        >
          <div
            className={classNames(css.section, {
              [css.signInLeftSection]: !isSignUp,
            })}
          >
            <div className={css.description}>
              <div className={css.headlineContainer}>
                <span className={css.headline}>
                  {hideTrial ? null : (
                    <div className={css.riskFreeBadge}>
                      100% Risk-Free Trial
                    </div>
                  )}
                  Your journey from Donkey Land to Unicorn Land starts here
                </span>

                <span className={css.subtitle}>
                  Let MobileMonkey help you find your unicorn leads in a sea of
                  donkeys using messaging automation that outsells human reps
                  10X
                </span>
              </div>

              <div className={css.image}>
                <img src={rainbowUnicorn} alt="Rainbow Unicorn" />
              </div>
            </div>
          </div>

          <div className={css.section}>
            <div className={css.card}>
              {!isResetPassword && (
                <Badges
                  className={classNames(css.badges, {
                    [css.centeredBadges]: !(isSignUp || !hideTrial),
                  })}
                  isSignUp={isSignUp && !hideTrial}
                />
              )}
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
